export default __webpack_public_path__ + "static/media/Ballroll_00106.f28a8889.png";